import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTrashAlt,
  faPlusCircle,
  faClock,
  faFireAlt,
  faSearch,
  faTimesCircle,
  faChevronCircleDown,
  faGripLines
} from '@fortawesome/free-solid-svg-icons'

// import {
//   faLinode
// } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library
  .add(
    faTrashAlt,
    faPlusCircle,
    faClock,
    faFireAlt,
    faSearch,
    faTimesCircle,
    faChevronCircleDown,
    faGripLines
  )

Vue.component('font-awesome-icon', FontAwesomeIcon)
